import { Button } from "@mui/material"
import { openGenericObjectModal } from "../ModalGenericObject/useGenericObjectModalStore";
import { fieldReferenciaKardex } from "@/shared/utils/fields-modal-generic-object";
import { IDataMovimientoInventario } from "@/shared/interfaces";

type InfoNumeroReferenciaProps = {
  movimiento_inventario_data?: IDataMovimientoInventario[] | null
  emptyFallback?: string
}

export default function InfoNumeroReferencia({
  movimiento_inventario_data,
}: InfoNumeroReferenciaProps) {

  if (!movimiento_inventario_data || !movimiento_inventario_data.length) {
    return '—'
  }

  const ref = movimiento_inventario_data.map(e => e.codigo).join(', ')

  if (ref.length <= 33) {
    return ref
  }

  return <div>
    <span>
      {ref.substring(0, 33)}...
    </span>
    <Button
      color='inherit'
      onClick={() => {
        openGenericObjectModal({
          data: {
            referencia_kardex: ref
          },
          fields: fieldReferenciaKardex,
          title: "ℹ️ Información",
          emptyFallback: "—",
        });
      }}
    >
      Ver todo
    </Button>
  </div>


}